import createTheme from '@mui/material/styles/createTheme';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import { ReactNode } from 'react';

const pulseTheme = createTheme({
  components: {
    MuiLink: {
      defaultProps: {
        underline: 'hover',
      },
    },
    MuiButton: {
      styleOverrides: {
        textPrimary: '#000000',
        textInherit: '#000000',
        textSecondary: '#000000',
      },
    },
  },
  palette: {
    controlText: {
      light: 'rgba(0, 0, 0, 0.87)',
      main: 'rgba(0, 0, 0, 0.87)',
      dark: 'rgba(0, 0, 0, 0.87)',
      contrastText: 'rgba(0, 0, 0, 0.87)',
    },
    primary: {
      light: '#757ce8',
      main: '#3f50b5',
      dark: '#002884',
      contrastText: '#fff',
    },
    secondary: {
      light: '#ff7961',
      main: '#f44336',
      dark: '#ba000d',
      contrastText: '#000',
    },
  },
});

export function PulseTheme({ children }: { children: ReactNode }) {
  return <ThemeProvider theme={pulseTheme}>{children}</ThemeProvider>;
}

declare module '@mui/material/styles' {
  interface Palette {
    controlText: Palette['primary'];
  }

  interface PaletteOptions {
    controlText: any;
  }
}
